import React, { useState } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { SvgIcon } from '../../calendar/components/svg-icon';
export const EventList = (props) => {
    const { events, paginationLimit, selectedDate, resetDate, currentPage, setCurrentPage, relatedInfoLabel, nextAvailableDate, goToNextAvailableDate, showAllMonthPerformancesText, nextAvailableDateText, todaysDate, emptyMonthMessaging, activeMonth, nextMonthCta, previousMonthCta } = props;
    const getCurrentPage = () => {
        const startIndex = currentPage * paginationLimit - paginationLimit;
        const endIndex = startIndex + paginationLimit;
        return events.slice(startIndex, endIndex);
    };
    const totalPages = Math.ceil(events.length / paginationLimit);
    const showAllForMonthText = showAllMonthPerformancesText.replace("{0}", activeMonth.format('MMMM'));
    return (<section className="pdp-event-list-container" aria-labelledby="event-list-heading">
            {events.length > 0 ?
            <ul className="pdp-event-list">
                        {getCurrentPage().map((event, index) => (!!event &&
                    <Event {...{ event, relatedInfoLabel, todaysDate }} key={index}/>))}
                    </ul>
            : <div className="rich-text" dangerouslySetInnerHTML={{ __html: emptyMonthMessaging }}/>}
            {events.length > paginationLimit &&
            <nav className="pagination-nav" aria-labelledby="event-pagination-heading">
                    <h4 className="visually-hidden" id="event-pagination-heading">{`Pagination, ${paginationLimit} at a time`}</h4>
                    <ul className="pagination-list">
                        <li>
                            <button type="button" onClick={() => setCurrentPage(currentPage - 1)} className="icon-btn pagination-btn" disabled={currentPage === 1}>
                                <span className="visually-hidden">Previous Page</span>
                                <SvgIcon iconId={"arrow-left"}/>
                            </button>
                        </li>
                        {[...Array(totalPages)].map((x, index) => (<li>
                                    <button type="button" onClick={() => setCurrentPage(index + 1)} className="icon-btn pagination-btn" aria-current={currentPage === index + 1}>{index + 1}</button>
                                </li>))}
                        <li>
                            <button type="button" onClick={() => setCurrentPage(currentPage + 1)} className="icon-btn pagination-btn" disabled={currentPage === totalPages}>
                                <span className="visually-hidden">Next Page</span>
                                <SvgIcon iconId={"arrow-right"}/>
                            </button>
                        </li>
                    </ul>
                </nav>}
            {!!selectedDate &&
            <div className="pdp-event-messaging">
                    <button type="button" className="btn-custom" onClick={resetDate}>{showAllForMonthText}</button>
                    <button type="button" className="pagination-next btn-with-icon" disabled={!nextAvailableDate} onClick={goToNextAvailableDate}>{nextAvailableDateText} <SvgIcon iconId={"arrow-right"}/></button>
                </div>}
            {(!!nextMonthCta || !!previousMonthCta) && !selectedDate &&
            <nav className={`flex-between pagination-months ${!nextMonthCta && "pagination-month-prev-only"}`}>
                    {!!previousMonthCta ? previousMonthCta : <span></span>}
                    {!!nextMonthCta ? nextMonthCta : <span></span>}
                </nav>}
        </section>);
};
const Event = (props) => {
    const { event, relatedInfoLabel, todaysDate } = props;
    dayjs.extend(utc);
    dayjs.extend(timezone);
    const timezoneName = 'America/New_York';
    const eventDate = dayjs(event?.eventDate).tz(timezoneName);
    const [detailsOpen, setDetailsOpen] = useState(false);
    const getCta = () => {
        if (todaysDate.isAfter(event.eventDate)) {
            return <></>;
        }
        let ctaText = '';
        let ctaLink = '';
        let ctaAccessibleText = '';
        if (event.onSale) {
            if (event.isAvailable) {
                ctaText = event.buyTicketCtaText || "Buy Tickets";
                ctaLink = event.buyTicketCtaUrl || '';
                ctaAccessibleText = event.buyTicketsLinkTitle;
            }
            else {
                ctaText = event.ticketsNoAvailabilityText;
            }
        }
        else {
            ctaText = event.ticketsNotOnSaleText;
        }
        if (ctaLink) {
            return (<a href={ctaLink} className="btn-custom" aria-label={ctaAccessibleText || undefined}>
                    {ctaText}
                </a>);
        }
        else {
            return (<p className="italic">{ctaText}</p>);
        }
    };
    return (<li className="pdp-event-item">
            <div className="pdp-event-item-date">
                <p className="large bold">
                    {dayjs(eventDate).format("MMM D")}
                </p>
                <p>
                    {dayjs(eventDate).format("ddd")}
                </p>
            </div>
            <div className="pdp-event-item-time">
                <p>
                    {event?.eventTimeString} {!!event?.programName ? <>&mdash; <span className="bold" dangerouslySetInnerHTML={{ __html: event.programName }}/></> : null}
                </p>
                {!!event?.moreInfo &&
            <div>
                        <button type="button" className="btn-reveal small bold" onClick={() => setDetailsOpen(!detailsOpen)} aria-expanded={detailsOpen}>{relatedInfoLabel}<span>&nbsp;<SvgIcon iconId={"arrow-down"} cssClass="btn-reveal-icon"/></span></button>
                        <div className="rich-text align-center space-top-xs" hidden={!detailsOpen}>
                            <p className="small" dangerouslySetInnerHTML={{ __html: event.moreInfo }}/>
                        </div>
                    </div>}
            </div>
            <p className="pdp-event-item-cta">
                {getCta()}
            </p>
        </li>);
};
